var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5925 3.98035C11.305 3.50421 12.1428 3.25008 12.9999 3.25008C14.1492 3.25008 15.2514 3.70663 16.0641 4.51928C16.8767 5.33194 17.3332 6.43411 17.3332 7.58337C17.3332 8.44043 17.0791 9.27825 16.603 9.99086C16.1268 10.7035 15.45 11.2589 14.6582 11.5869L15.0728 12.5878L14.6582 11.5869C13.8664 11.9149 12.9951 12.0007 12.1545 11.8335C11.314 11.6663 10.5418 11.2536 9.93579 10.6475C9.32976 10.0415 8.91705 9.26936 8.74985 8.42877C8.58265 7.5882 8.66847 6.71691 8.99645 5.92509C9.32443 5.13327 9.87984 4.4565 10.5925 3.98035Z",
    stroke: "#AFAFAF",
    strokeWidth: 2.16667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9933 15.1671L12.9933 15.1671L13.0059 15.1671C15.2956 15.1546 17.5129 15.7744 19.3216 16.913L19.3411 16.9253L19.3611 16.9367C20.0331 17.3208 20.5806 17.8171 20.9753 18.3795L21.8255 17.7828L20.9753 18.3795C21.3568 18.9229 21.5879 19.5168 21.6661 20.1203C21.6603 20.3307 21.6047 20.5445 21.4946 20.7508C21.3768 20.9715 21.1966 21.1833 20.9537 21.3639C20.3464 21.781 19.6253 22.0847 18.8414 22.2437C14.9834 22.919 11.0019 22.919 7.14394 22.2437C6.36146 22.085 5.64168 21.7821 5.0351 21.3663C4.79602 21.1851 4.61866 20.9737 4.50278 20.7537C4.39347 20.5462 4.33865 20.3313 4.3337 20.1197C4.40911 19.5158 4.63897 18.9213 5.02064 18.3775C5.41492 17.8157 5.96297 17.3204 6.63609 16.9383L6.65792 16.9259L6.67916 16.9125C8.48641 15.7727 10.7038 15.1529 12.9933 15.1671Z",
    stroke: "#AFAFAF",
    strokeWidth: 2.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.d92a3770d5e622d831f1e61cd32538f3.svg";
export { ForwardRef as ReactComponent };